/* A single native form owns variant, price, availability, validation and cart. */
if (!customElements.get('pw-gallery')) {
  customElements.define('pw-gallery', class extends HTMLElement {
    connectedCallback() {
      this.onClick = (event) => {
        const button = event.target.closest('[data-pw-show]');
        if (!button || !this.contains(button)) return;
        this.querySelectorAll('[data-pw-photo]').forEach((photo) => { photo.hidden = photo.dataset.pwPhoto !== button.dataset.pwShow; });
        this.querySelectorAll('[data-pw-show]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      };
      this.addEventListener('click', this.onClick);
    }
    disconnectedCallback() { this.removeEventListener('click', this.onClick); }
  });
}

if (!window.peitwayPurchase) {
  window.peitwayPurchase = (() => {
    let cleanup = () => {};
    const boot = () => {
      cleanup();
      const root = document.querySelector('[data-pw-product]');
      const main = root?.querySelector('product-form [type="submit"][name="add"]');
      const price = root?.querySelector('[data-pw-main-price]');
      const sticky = root?.querySelector('[data-pw-sticky]');
      if (!main || !price || !sticky) return;
      const form = root.querySelector('product-form');
      const close = document.querySelector('[data-pw-close]');
      if (close) close.hidden = false;
      const stickyButton = sticky.querySelector('[data-pw-sticky-button]');
      const proxies = [stickyButton, close].filter(Boolean);
      let frame = 0;
      let lastPrice = '';
      let lastLabel = '';
      let wasModalOpen = false;
      let lastProxy = null;
      const isVisible = (element) => {
        if (!element || element.hidden) return false;
        const style = getComputedStyle(element);
        return style.display !== 'none' && style.visibility !== 'hidden' && element.getBoundingClientRect().height > 0;
      };
      const update = () => {
        frame = 0;
        const busy = main.classList.contains('loading');
        const disabled = main.disabled || main.getAttribute('aria-disabled') === 'true' || busy;
        const label = busy ? 'Agregando…' : main.querySelector('span:not(.loading__spinner)')?.textContent.trim() || main.textContent.trim();
        proxies.forEach((button) => {
          button.setAttribute('aria-disabled', String(disabled));
          button.setAttribute('aria-busy', String(busy));
          if (button.tagName === 'BUTTON' && button.disabled !== disabled) button.disabled = disabled;
          if (label !== lastLabel) button.textContent = label;
        });
        lastLabel = label;
        const priceNode = price.querySelector('.price--on-sale .price-item--sale') || price.querySelector('.price__regular .price-item--regular');
        const priceText = price.classList.contains('hidden') ? '' : (priceNode?.textContent.trim() || '');
        const stickyPrice = sticky.querySelector('[data-pw-price]');
        if (stickyPrice.textContent !== priceText) stickyPrice.textContent = priceText;
        const closePrice = document.querySelector('[data-pw-close-price]');
        const priceKey = String(price.classList.contains('hidden')) + price.innerHTML;
        if (closePrice && priceKey !== lastPrice) {
          closePrice.innerHTML = price.classList.contains('hidden') ? '' : price.innerHTML;
          lastPrice = priceKey;
        }
        const error = form.querySelector('.product-form__error-message-wrapper');
        const errorTarget = sticky.querySelector('[data-pw-sticky-error]');
        const errorText = error && !error.hidden ? error.querySelector('.product-form__error-message')?.textContent.trim() || '' : '';
        if (errorTarget.textContent !== errorText) errorTarget.textContent = errorText;
        if (errorTarget.hidden !== !errorText) errorTarget.hidden = !errorText;
        const modalOpen = Boolean(document.querySelector('cart-drawer.active, cart-notification.active, product-modal[open], modal-dialog[open], .menu-drawer-container[open], details-modal details[open], dialog[open]'));
        const cookieOpen = [...document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs, [data-pw-hide-sticky]')].some(isVisible);
        const keyboard = /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName || '');
        const closeRect = close?.getBoundingClientRect();
        const closeVisible = closeRect && closeRect.top < window.innerHeight && closeRect.bottom > 0;
        const pastMain = main.getBoundingClientRect().bottom < 0;
        const show = pastMain && !closeVisible && !modalOpen && !cookieOpen && !keyboard;
        if (sticky.hidden !== !show) sticky.hidden = !show;
        if (wasModalOpen && !modalOpen && !cookieOpen && lastProxy) {
          const focusTarget = show ? stickyButton : closeVisible ? close : main;
          focusTarget?.focus({ preventScroll: true });
          lastProxy = null;
        }
        wasModalOpen = modalOpen;
        const height = show ? sticky.offsetHeight : 0;
        const heightValue = `${height}px`;
        if (document.documentElement.style.getPropertyValue('--pw-sticky-height') !== heightValue) document.documentElement.style.setProperty('--pw-sticky-height', heightValue);
        document.dispatchEvent(new CustomEvent('peitway:sticky', { detail: { visible: show, modal: modalOpen || cookieOpen } }));
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      const submit = (event) => {
        event.preventDefault();
        if (main.disabled || main.getAttribute('aria-disabled') === 'true' || main.classList.contains('loading')) return;
        lastProxy = event.currentTarget;
        // One click, one native listener. No second form, fetch or analytics event.
        main.click();
        schedule();
      };
      proxies.forEach((button) => { button.addEventListener('click', submit); });
      const purchaseObserver = new MutationObserver(schedule);
      purchaseObserver.observe(form, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled', 'hidden'] });
      purchaseObserver.observe(price, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
      const pageObserver = new MutationObserver(schedule);
      pageObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'class', 'hidden'] });
      const viewportObserver = new IntersectionObserver(schedule, { threshold: [0, 1] });
      viewportObserver.observe(main);
      if (close) viewportObserver.observe(close);
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      document.addEventListener('focusin', schedule);
      document.addEventListener('focusout', schedule);
      window.visualViewport?.addEventListener('resize', schedule);
      schedule();
      cleanup = () => {
        cancelAnimationFrame(frame);
        purchaseObserver.disconnect(); pageObserver.disconnect(); viewportObserver.disconnect();
        proxies.forEach((button) => button.removeEventListener('click', submit));
        window.removeEventListener('scroll', schedule); window.removeEventListener('resize', schedule);
        document.removeEventListener('focusin', schedule); document.removeEventListener('focusout', schedule);
        window.visualViewport?.removeEventListener('resize', schedule);
        sticky.hidden = true;
        if (close) close.hidden = true;
        document.documentElement.style.setProperty('--pw-sticky-height', '0px');
        document.dispatchEvent(new CustomEvent('peitway:sticky', { detail: { visible: false, modal: false } }));
      };
    };
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:section:unload', () => { requestAnimationFrame(boot); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();
    return { boot };
  })();
}
